<div
  class="border-2 border-slate-200 rounded-md flex flex-1 flex-col gap-2"
  [ngClass]="{ 'h-0': collapsed }"
>
  <div>
    <dx-form
      [formData]="formData"
      (onFieldDataChanged)="onFieldDataChanged()"
      [colCount]="6"
      [showColonAfterLabel]="false"
      [readOnly]="readonly"
    >
      <dxi-item
        dataField="title"
        editorType="dxTextBox"
        [label]="{ text: 'Nome' | transloco, location: 'top' }"
        [editorOptions]="{ placeholder: 'Titolo' | transloco }"
        [colSpan]="2"
      ></dxi-item>
      <dxi-item
        dataField="cols"
        editorType="dxSelectBox"
        [label]="{ text: 'Colonne' | transloco, location: 'top' }"
        [editorOptions]="{
          dataSource: ['1', '2', '3', '4', '5', '6', '7', '8']
        }"
      ></dxi-item>
    </dx-form>
  </div>
  <div class="flex h-min">
    <ng-container
      [ngTemplateOutlet]="templateOutlet"
      [ngTemplateOutletContext]="{
        $implicit: item.config?.group || [],
        groupName: 'report-designer',
        groupTarget: item.config.name,
        scrollable: false,
        cols: item.config.cols || '1',
        level: level + 1,
        parentName: item.config.name,
        containerName: item.friendlyName || item.config.name,
        groupTitle: formData.title,
        templateArrayOwner: item.config,
        templateArrayKey: 'group'
      }"
    ></ng-container>
  </div>
</div>
